import { useCallback } from 'react';

import { parseAsString, useQueryStates } from 'nuqs';

import { STRIPE_QUERY_PARAMS } from '../constants';

export const useStripeParams = () => {
   const [stripeParams, setStripeParams] = useQueryStates({
      [STRIPE_QUERY_PARAMS.REDIRECT_STATUS]: parseAsString,
      [STRIPE_QUERY_PARAMS.PAYMENT_INTENT]: parseAsString,
      [STRIPE_QUERY_PARAMS.PAYMENT_INTENT_CLIENT_SECRET]: parseAsString
   });

   const clear = useCallback(async () => {
      await setStripeParams(null);
   }, []);

   return {
      redirectStatus: stripeParams[STRIPE_QUERY_PARAMS.REDIRECT_STATUS],
      paymentIntentId: stripeParams[STRIPE_QUERY_PARAMS.PAYMENT_INTENT],
      clientSecret: stripeParams[STRIPE_QUERY_PARAMS.PAYMENT_INTENT_CLIENT_SECRET],
      clear
   };
};
